'use client'

import type React from 'react'
import { signIn } from 'next-auth/react'
import { toast } from 'sonner'
import { openRegister } from '@/lib/actions'
import { useModals } from '@/lib/hooks'
import { useAppSelector } from '@/lib/hooks/use-redux'
import { cn } from '@/lib/utils'

import { InputForm } from '@/components/ui'

interface OpenRegisterProps extends React.ComponentPropsWithoutRef<'div'> {}

export const OpenRegister = ({ className }: OpenRegisterProps) => {
  const { closeModal } = useModals()
  const { userPin, userToken } = useAppSelector((state) => state.appSession)

  const handleRegister = async (openingBalance: any) => {
    try {
      await openRegister(openingBalance)
      toast.success('Logged in successfully')
      closeModal('OPEN_REGISTER')
    } catch (error: any) {
      toast.error(error?.message || 'Failed to open register')
    }
  }

  const handleSignIn = async (data: FormData) => {
    const openingBalance = data.get('opening-balance')

    if (!openingBalance || Number(openingBalance) < 0) {
      toast.error('Invalid opening balance')
      return
    }

    await signIn('credentials', {
      pin: userPin,
      token: userToken,
      redirect: false,
    }).then(async (res: any) => {
      if (!res.ok) {
        toast.error(res?.error || 'Something went wrong')
      } else {
        await handleRegister(openingBalance)
      }
    })
  }

  return (
    <form
      action={handleSignIn}
      className={cn('flex w-full flex-col', className)}
    >
      <div className="flex flex-col gap-2">
        <InputForm
          autoCorrect="off"
          autoComplete="off"
          maxLength={4}
          name="opening-balance"
          placeholder="10,000.00"
          className="lg:h-[44px]"
          icon={<span className="font-mono font-bold">Rs.</span>}
          submitLabel="Confirm"
          submitPendingLabel="Opening..."
          type="number"
          pattern="[0-9]*"
        />
      </div>
    </form>
  )
}
